<div *ngIf="label" class="bx--grid" [ngClass]="[disabled ? 'checkbox-disabled' : '', !label ? 'no-text' : '']">
  <div class="form-check bx--row" [ngClass]="[disabled ? 'checkbox-disabled' : '']">
    <label class="container bx--col checkbox-label" *ngIf="label"> <span [ngClass]="disabled ? 'disabled-button-title' : ''">{{label}}</span>
      <input type="checkbox" [checked]="checked" [indeterminate]="indeterminate"  (change)="change();" [disabled]="disabled">
      <span [ngClass]="(disabled ? 'disabled-' : '') + (indeterminate ? 'indeterminate' : 'checkmark')" style="margin-right: 8px"></span>
    </label>
  </div>
</div>
<div *ngIf="!label" [ngClass]="[disabled ? 'checkbox-disabled' : '', !label ? 'no-text' : '']">
  <div class="form-check" [ngClass]="[disabled ? 'checkbox-disabled' : '']">
    <label class="checkbox-label no-text-container" *ngIf="!label">
      <input type="checkbox" [checked]="checked" [indeterminate]="indeterminate" (change)="change();" [disabled]="disabled">
      <span style="margin: 0; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);"
            [ngClass]="(disabled ? 'disabled-' : '') + (indeterminate ? 'indeterminate' : 'checkmark')"></span>
    </label>
  </div>
</div>
